import { render, staticRenderFns } from "./LfInfoComponent.vue?vue&type=template&id=6ce3aa2d&scoped=true"
import script from "./LfInfoComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LfInfoComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LfInfoComponent.vue?vue&type=style&index=0&id=6ce3aa2d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce3aa2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce3aa2d')) {
      api.createRecord('6ce3aa2d', component.options)
    } else {
      api.reload('6ce3aa2d', component.options)
    }
    module.hot.accept("./LfInfoComponent.vue?vue&type=template&id=6ce3aa2d&scoped=true", function () {
      api.rerender('6ce3aa2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/message/LfInfoComponent.vue"
export default component.exports